import { useStoreState } from '@src/model/hooks';
import { getQueryParam, getUrlPath } from '@src/utils/url-utils/url-utils';
import type { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

const NoAuthRequiredRoute: FC<PropsWithChildren> = ({ children }) => {
    const isLoggedIn = useStoreState(state => state.user.isLoggedIn);
    const isAuthenticating = useStoreState(state => state.user.isAuthenticating);

    const navigateTo = getQueryParam('next');
    const isLoginRoute = getUrlPath() === '/bbs/login';

    if (isLoggedIn && isLoginRoute && navigateTo) {
        return <>{children}</>;
    }

    if (isAuthenticating === false && isLoggedIn) {
        return <Navigate to={'/'} replace />;
    }

    return <>{children}</>;
};

export default NoAuthRequiredRoute;
